import { Reveal } from "./Reveal";

export const LegalLayout = ({ title, updated, sections, testid }) => (
  <div data-testid={testid}>
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 dot-grid" aria-hidden="true" />
      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-10 md:pt-44 md:pb-14">
        <Reveal>
          <span className="inline-flex items-center rounded-full border border-brand-200 bg-brand-50 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-brand-700">
            Legal
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <h1 className="mt-6 font-display text-4xl sm:text-5xl font-bold tracking-tight text-slate-900 leading-[1.08]">
            {title}
          </h1>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-4 text-sm font-medium text-slate-500">Last updated: {updated}</p>
        </Reveal>
      </div>
    </section>
    <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 md:pb-28">
      <div className="space-y-10">
        {sections.map((s, i) => (
          <Reveal key={s.title} delay={Math.min(i * 0.04, 0.2)}>
            <div data-testid={`${testid}-section-${i + 1}`}>
              <h2 className="font-display text-xl font-bold text-slate-900">
                {i + 1}. {s.title}
              </h2>
              <p className="mt-3 text-base leading-relaxed text-slate-600">{s.body}</p>
              {s.points && (
                <ul className="mt-3 space-y-2">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-start gap-3 text-base leading-relaxed text-slate-600">
                      <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brand-600" aria-hidden="true" />
                      {p}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  </div>
);
